module.exports = __webpack_public_path__ + "static/media/learn_french_through_music.673be948.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/learn_french_through_music.jpg
// module id = 1269
// module chunks = 0